import { render } from "./CoachDetails.vue?vue&type=template&id=fc003eec&scoped=true"
import script from "./CoachDetails.vue?vue&type=script&lang=js"
export * from "./CoachDetails.vue?vue&type=script&lang=js"

import "./CoachDetails.vue?vue&type=style&index=0&id=fc003eec&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-fc003eec"

export default script